/* Synterra info pages — optional accordion enhancement.
   FAQ uses native <details>/<summary> (works without JS). This only adds
   "close others" behaviour per section for a cleaner UX. Progressive enhancement. */
(function () {
  'use strict';
  function init() {
    document.querySelectorAll('[data-synterra-info]').forEach(function (root) {
      var items = root.querySelectorAll('.synterra-info-faq');
      items.forEach(function (item) {
        item.addEventListener('toggle', function () {
          if (!item.open) return;
          items.forEach(function (other) {
            if (other !== item && other.open) other.open = false;
          });
        });
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
